<div class="modal-header">
  <h4 class="modal-title drop-modal-title">Verify bank account</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>

<div class="modal-body">
  <p class="mb-2">Enter the 6-character code from your bank statement to verify your account.</p>

  <p class="mb-3" *ngIf="last4">
    We deposited <strong>$0.01</strong> to ••••{{ last4 }}
    <span *ngIf="expectedArrivalDateText"> on {{ expectedArrivalDateText }}</span>.
    To verify this account, enter the 6-character code starting with <strong>SM</strong> from that deposit.
  </p>

  <div class="verify-row">
    <span class="prefix">S</span>
    <span class="prefix">M</span>
    <input
      class="code-input"
      type="text"
      maxlength="4"
      [(ngModel)]="codeSuffix"
      [disabled]="submitted"
      placeholder="XXXX"
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
    />
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-dark verify-submit" (click)="onVerify()" [disabled]="submitted">
    <span *ngIf="submitted" class="spinner-border spinner-border-sm" role="status"></span>
    <span *ngIf="!submitted">Verify</span>
  </button>
</div>
